export default {
      id: "icon-compare-usage",
      viewBox: "0 0 14 16",
      url: __webpack_public_path__ + "./images/svg/symbols.svg#icon-compare",
      toString: function () {
        return this.url;
      }
    }